import { createSelector } from 'reselect';
import getModuleState from './moduleStateSelector';

export const getForm = createSelector(
  getModuleState,
  (state) => state.get('form')
);

export const getIsSubmitted = createSelector(
  getForm,
  (state) => state.get('isSubmitted')
);

export const getIsTravelerModalOpen = createSelector(
  getForm,
  (state) => state.get('isTravelerModalOpen')
);
